
import { Component, Inject, OnInit, Renderer2, DOCUMENT, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
    selector: 'ep-egg-starwars',
    templateUrl: './starwars.component.html',
    styleUrls: ['./starwars.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})

export class StarwarsComponent implements OnInit {

    constructor(@Inject(DOCUMENT) private document: Document, private renderer: Renderer2) { }

    productteam = [
        "Asger Smidt",
        "Daniel Dall",
        "David Sand",
        "Frank Jensen",
        "Henrik Rasmussen",
        "Michael Hansen",
        "Thorsten Roy",
        "Lars Bang-Madsen",
        "Mikkel Bo Mikkelsen",
        "Mikael Flensborg",
        "",
        "Simon Lausten",
        "Henrik Engmark",
        "Mads Illeman"
    ];

    year = new Date().getFullYear();

    ngOnInit(): void {
        this.renderer.setStyle(this.document.body, "background-color", "#2e2e2e");
        this.productteam = this.shuffleArray(this.productteam);
    }

    shuffleArray<T>(array: T[]): T[] {
        let shuffledArray = array.slice(); // Create a copy of the original array
        for (let i = shuffledArray.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1)); // Get a random index
            [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]]; // Swap elements
        }
        return shuffledArray;
    }
}
